import { useIntl } from "react-intl";
import { CloseButton } from "src/auth/components/CloseButton/CloseButton";
import CalendarReturn from "src/design-system/icons/CalendarReturn.svg?react";
import XCircleSolid from "src/design-system/icons/XCircleSolid.svg?react";
import CalendarDepart from "src/design-system/icons/CalendarDepart.svg?react";
import { Button } from "react-aria-components";
import segmentScreenMessages from "../../SegmentScreen.messages";
import DateInput from "./DateInput";

type Props = {
  departureDate?: Date;
  returnDate?: Date;
  departureInputText: string;
  returnInputText: string;
  handleReturnInputClick: () => void;
  handleDepartureInputClick: () => void;
  handleReturnRemoveClick: () => void;
  handleCloseButtonClick: (inputOpen: "departure" | "return") => void;
  inputOpen: "departure" | "return";
  blinkDeparture: boolean;
  isReturnable: boolean;
};

export default function DatePopoutHeader({
  departureDate,
  returnDate,
  departureInputText,
  returnInputText,
  handleReturnInputClick,
  handleDepartureInputClick,
  handleReturnRemoveClick,
  handleCloseButtonClick,
  inputOpen = "departure",
  blinkDeparture = true,
  isReturnable,
}: Props) {
  const intl = useIntl();

  return (
    <div className="mb-5 flex w-full flex-row flex-wrap justify-center gap-4 px-4 pt-4 pb-3 shadow-lg">
      <h2 className="w-full text-center text-heading-sm font-semibold">
        {intl.formatMessage(segmentScreenMessages.chooseDates)}
      </h2>
      {isReturnable && (
        <div className="flex w-full justify-center">
          <div className="relative flex w-full gap-2">
            <DateInput
              mode="popout"
              date={departureDate}
              icon={<CalendarDepart />}
              isOpen={inputOpen === "departure"}
              text={departureInputText}
              buttonProps={{
                "aria-label": departureInputText,
                onPress: handleDepartureInputClick,
              }}
              blink={blinkDeparture}
            />
            <DateInput
              mode="popout"
              date={returnDate}
              text={returnInputText}
              icon={returnDate && <CalendarReturn />}
              isOpen={inputOpen === "return"}
              buttonProps={{
                "aria-label": returnInputText,
                onPress: handleReturnInputClick,
              }}
              blink={false}
            />
            {returnDate && (
              <Button
                className="absolute top-1/2 right-0 z-10 -translate-y-1/2 cursor-pointer p-2 text-neutral-alpha-1100 transition-transform hover:scale-120 hover:text-neutral-alpha-1300"
                onPress={handleReturnRemoveClick}
              >
                <XCircleSolid className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
      )}

      <CloseButton
        onClick={() => handleCloseButtonClick(inputOpen)}
        className="absolute top-3 right-2"
      />
    </div>
  );
}
